export const technologies = {
    HTML: "HTML 5",
    CSS: "CSS 3",
    JavaScript: "JavaScript",
    Node: "Node",
    ExpressJS: "ExpressJS",
    ReactJS: "ReactJS",
    SciterJS: "SciterJS",
    SQL: "SQL",
    NoSQL: "NoSQL",
    AJAX: "AJAX",
    JSON: "JSON",
    jQuery: "jQuery",
    Bootstrap: "Bootstrap 5",
    PHP: "PHP",
}
// https://www.jobseeker.com/en/resume/articles/resume-soft-skills?cq_src=google_ads&cq_cmp=15092453692&cq_term=&cq_plac=&cq_net=g&cq_plt=gp&gad=1&gclid=CjwKCAjwgqejBhBAEiwAuWHioB4gbmiId5ZL9uRPrJf_gzE7qfKdx2H8jOPnY0VgalldS2DHBtfiwxoCBq8QAvD_BwE
export const softSkills = [
    {
        "Communication skills:": [
            { "Giving and receiving constructive feedback": 94 },
            { "Friendliness": 98 },
            { "Storytelling": 80 },
            { "Mutual respect": 90 },
            { "Public speaking": 70 },
        ],
    },
]
export const precentHardSkillsTechnologies = {
    HTML: 95,
    CSS: 95,
    JavaScript: 80,
    Node: 30,
    ExpressJS: 10,
    ReactJS: 80,
    SciterJS: 90,
    NoSQL: 40,
    jQuery: 70,
    Bootstrap: 60,
}
export const layoutTechnology = {
    media: "Responsive Design (Media Queries)",
    mediaVariable: "Implemented Variable Media Queries for flexible responsiveness",
    skeleton: {
        flexBoxCalc: "Implemented Adaptive Flex-box Grid using calc()",
        bootstrap: "Utilized Adaptive Bootstrap Grid (version 4.4.1)",
    },
    technology: "Advanced Flex-box Layout (HTML5, CSS3)",
    BEM: "Utilized Block Element Modifier (BEM) methodology for modular and reusable code",
    W3C: "Valid Markup according to W3C Specifications",
    modalWindow: {
        jquery: "Implemented Modal Window functionality using jQuery",
    },
    adaptiveImg: "Image Adaptation for optimal display across devices",
    CSSPreprocessors: {
        less: "Utilized Less preprocessor for streamlined CSS development",
        scss: "Utilized SCSS preprocessor for enhanced CSS features and organization",
        scssVariables: "Implemented structured color palette using Sass variables",
    },
};

export const automation = {
    gulp: "Utilized Gulp 4 as a task runner for automated workflows",
    gulpScssStarter: "Configured and utilized gulp-scss-starter build system (babelrc, bemrc, eslintrc, stylelintrc, webpack)",
};

export const nameSection = {
    layout: "Layout:",
    pluginsLibraries: "Libraries & Plugins:",
    applications: "Applications & Utilities:",
    features: "Implemented Features:",
};

export const pluginsLibraries = {
    jquery: {
        scroll: "Implemented Smooth Scrolling to Anchor Points with fixed header using jQuery",
        accordion: "Implemented Accordion functionality using data attributes (jQuery)",
        slickSlider: "Utilized jQuery-Slick-Slider for creating responsive sliders",
        validateForm: "Implemented Form Validation for enhanced user feedback using jquery-validate",
    },
    bundlers: {
        parcel: "Utilized Parcel as an efficient application bundler",
    },
    axios: "Utilized Axios.js library for simplified data retrieval",
};

export const feature = {
    feedback: "Implemented Feedback Form with server-side functionality for effective user communication (Ajax, PHP)",
    GoogleMapsAPI: "Integrated Google Maps API for interactive map with marker placement",
};

export const applications = {
    git: "Utilized Git for distributed version control and collaboration",
    textEditor: {
        brackets: "Utilized Brackets as a lightweight text editor",
        sublimeText: "Utilized Sublime Text 3 as a versatile text editor",
        VSCode: "Utilized Visual Studio Code (VSCode) as a powerful text editor",
    },
    graphicsEditor: {
        adobePhotoshop: "Utilized Adobe Photoshop for design layouts and image editing (Desktop-First approach)",
        adobeXD: "Utilized Adobe XD for designing and prototyping user interfaces (Desktop-First approach)",
    },
};

export const typePage = {
    landing: "Landing page",
    page: "Web page",
    site: "Site",
};